import React, {useContext, useEffect, useState} from 'react';
import {Input, Table} from 'reactstrap';
import axios from "axios";
import Pagination from "../Pagination";
import {handleError, showsuccesToast} from "../HandleError";
import TableSkeleton from "../Skeleton/DashboardTableSkeleton";
import ConfirmationModel from "../ConfirmationModel";
import localized from '../../i18n';
import DashboardTableBody from "./DashboardTableBody";
import authContext from "../../AuthProvider/authContext";

const DashboardTable = (props) => {
    const {isLoadingStocks, recentStocks, getFilesList } = props;
    const [showDeleteModel, setShowDeleteModel] = useState({
        isOpen: false,
        currentElement: null,
    });
    const {updateAuth} = useContext(authContext)


    const toggleDeleteModel = (element = null) => {
        setShowDeleteModel((prev) => ({
            ...prev,
            isOpen: !showDeleteModel.isOpen,
            currentElement: element,
        }));
    }

    const deleteFile = (values, setSubmitting) => {
        setSubmitting(true);
        setTimeout(()=> {
            axios.delete(`/api/file/${showDeleteModel.currentElement}`)
                .then((response) => {
                    toggleDeleteModel();
                    setSubmitting(false);
                    showsuccesToast(localized.file_deleted_successfully);
                    getFilesList();
                }).catch((err) => {
                setSubmitting(false);
                handleError(err);
            })
        },500);
    }

    return (
        <div className="DashboardTable-main">
            <div className="DashboardTable-container">
                <div className={"table-header"}>
                    <h3>{localized.History_of_uploaded}</h3>
                    <Input
                        className="user_action"
                        name="select"
                        type="select"
                        defaultValue={50}
                        onChange={(e) => {
                            updateAuth({filter: e.target.value});
                        }}
                    >
                        <option value={""}>
                            All
                        </option>
                        <option value={"today"}>
                            Today
                        </option>
                    </Input>
                </div>
                <Table borderless={true} responsive={true} className={"dashboard-table"}>
                    <thead>
                    <tr>
                        <th>{localized.id}</th>
                        <th>{localized.name_of_the_list}</th>
                        <th>{localized.creation_date}</th>
                        <th>{localized.beginning}</th>
                        <th>{localized.end}</th>
                        <th>{localized.total_email}</th>
                        {/*<th>{localized.ProcessedEmail}</th>*/}
                        <th>{localized.valid_email}</th>
                        {/*<th>{localized.invalid_email}</th>*/}
                        <th className={"text-center"}>{localized.result}</th>
                        <th className={"text-center"}>{localized.action}</th>
                    </tr>
                    </thead>

                    <tbody>
                        {isLoadingStocks && <TableSkeleton/>}
                        {!isLoadingStocks && recentStocks && (
                            <DashboardTableBody
                                {...props}
                                toggleDeleteModel={toggleDeleteModel}
                            />
                        )}
                    </tbody>
                </Table>

                {!isLoadingStocks && (recentStocks.data || []).length !== 0 && (
                    <Pagination
                        page={recentStocks.current_page - 1}
                        pages={recentStocks.last_page}
                        canPrevious={true}
                        canNext={true}
                        onPageChange={(page) => props.getFilesList(page + 1)}
                    />
                )}
            </div>
            <ConfirmationModel
                title={localized.are_you_sure_want_to_delete_this_item}
                isOpen={showDeleteModel.isOpen}
                submitBtn={localized.delete_item}
                className="logout-modal"
                onClose={() => toggleDeleteModel()}
                onSubmit={deleteFile}
            />
        </div>
    );
};

export default DashboardTable;
